import React, { FC } from 'react'
import { Typography } from 'antd'
import { TooltipProps } from 'recharts'
import { convertNumberToCommaSeperated } from '../../../utils'
import RChartTooltipContainer from './styles'

interface RChartTooltipProps extends TooltipProps<number, string> {
  labelKey?: 'name' | 'dataKey' | 'value'
  removeKeys?: string[]
  addKeys?: string[]
}

const QChartTooltip: FC<RChartTooltipProps> = ({
  active,
  payload,
  label,
  labelKey = 'dataKey',
  removeKeys = [],
  addKeys = [],
}) => {
  if (active && payload && payload.length) {
    return (
      <RChartTooltipContainer>
        {label && <Typography.Title level={5}>{label}</Typography.Title>}
        {payload
          .filter(({ dataKey }) => !removeKeys?.includes(dataKey?.toString() || ''))
          .map((data) => (
            <Typography.Text
              className='d-block'
              key={data.dataKey}
              style={{ color: data.color || data.payload.fill }}
            >
              {data[labelKey]}: <b>{convertNumberToCommaSeperated(data.value || 0)}</b>
            </Typography.Text>
          ))}

        {addKeys.map(
          (key) =>
            payload.length && (
              <Typography.Text className='d-block' key={key}>
                {key}: <b>{convertNumberToCommaSeperated(payload[0]?.payload[key] || 0)}</b>
              </Typography.Text>
            ),
        )}
      </RChartTooltipContainer>
    )
  }
  return null
}

export default QChartTooltip
